import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { ValidationError } from "../ScoreCardValidation/ValidationSchema.tsx";
import QuestionItem from "./QuestionItem.tsx";

interface QuestionsBankProps {
  questionsData: any;
  currentCategoryIndex: number;
  uploadedFiles: Record<string, File[]>;
  answers: Record<string, any>;
  setAnswer: any;
  setUploadedFiles: any;
  onAnswerChange: (questionId: any, value: any) => void;
  onCommentChange: (questionId: number, comment: string) => void;
  onFileUpload: (
    event: React.ChangeEvent<HTMLInputElement>,
    section: string
  ) => void;
  onPreviousCategory: () => void;
  onNextCategory: () => void;
  onRemoveFile: (section: string, index: number) => void;
  validationErrors?: ValidationError[];
  showPreview?: any;
}

// Update the QuestionsBank component to pass validation errors to QuestionItem
const QuestionsBank: React.FC<QuestionsBankProps> = ({
  questionsData,
  currentCategoryIndex,
  uploadedFiles,
  answers,
  setAnswer,
  setUploadedFiles,
  onAnswerChange,
  onCommentChange,
  onFileUpload,
  onPreviousCategory,
  onNextCategory,
  onRemoveFile,
  validationErrors,
  showPreview
}) => {
  console.log(questionsData);

  const totalQuestionsCount = questionsData.totalQuestionsCount;
  const totalAnsweredCount = questionsData.totalAnsweredCount;
  const totalunAnsweredCount = questionsData.totalUnansweredCount;

  // Get current category
  const currentCategory = questionsData.questions[currentCategoryIndex];
  console.log(currentCategory);

  // Add a function to check if a question has image validation errors
  const getQuestionImageErrors = (questionId: number) => {
    return (
      validationErrors?.filter(
        (error) => error.field === `question_${questionId}_images`
      ) || []
    );
  };

  return (
    <Stack spacing={4}>
      <Box
        className={showPreview ? '' : "questionBankHeader"}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          //bgcolor: "#f5f5f5",
          p: 2,
          borderRadius: "10px",
        }}
      >
          {/* Left section - Step indicator */}
          <Typography sx={{ fontWeight: 600, fontSize: 16 }}>
            {`${currentCategoryIndex + 1}/${
              questionsData.questions.length
            } - ${currentCategory.categoryName.toUpperCase()}`}
          </Typography>

          {/* Middle section - Question statistics */}
          {/* <Box sx={{ display: "flex", alignItems: "center", fontSize: 14 }}>
            <Typography component="span">
              Total Questions: {totalQuestionsCount}
            </Typography>
            <Typography component="span" sx={{ mx: 0.5, color: "text.disabled" }}>
              |
            </Typography>
            <Typography component="span" sx={{ mx: 0.5, color: "text.secondary" }}>
              Answered: {totalAnsweredCount}
            </Typography>
            <Typography component="span" sx={{ mx: 0.5, color: "text.disabled" }}>
              |
            </Typography>
            <Typography component="span" sx={{ color: "error.main" }}>
              Remaining: {totalunAnsweredCount}
            </Typography>
          </Box> */}
      </Box>

      <Stack spacing={3} className={showPreview ? '' : "questionBankContent"} >
        {Array.from(
          new Map(
            currentCategory.questions.map((q) => [q.questionId, q])
          ).values()
        ).map((question: any, index) => (
          <QuestionItem
            questionsData={questionsData}
            key={question.questionId} // key must be unique!
            question={question}
            index={index}
            answers={answers}
            setAnswer={setAnswer}
            setUploadedFiles={setUploadedFiles}
            uploadedFiles={uploadedFiles}
            onAnswerChange={onAnswerChange}
            onCommentChange={onCommentChange}
            onFileUpload={onFileUpload}
            onRemoveFile={onRemoveFile}
            validationErrors={[
              ...(validationErrors || []),
              ...getQuestionImageErrors(question.questionId),
            ]}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default QuestionsBank;